export const xmUpdateIncidentStep = '7400e10a-7384-5474-b41c-f7c7ebc3938d';

export const isXmUpdateIncidentStep = step =>
  (step?.id ?? step?.uuid) === xmUpdateIncidentStep;
